import { Characteristics } from '../../schema/VehicleTileDataSchema';
import type { ParsedTechnicalData } from './TechnicalDataOneSearch';

export const processOneSearchCharacteristics = (
  parsedTechnicalData: Partial<ParsedTechnicalData>,
): Characteristics[] => {
  const characteristics: Characteristics[] = [];

  if (parsedTechnicalData.engineDescription) {
    characteristics.push(parsedTechnicalData.engineDescription);
  }

  if (parsedTechnicalData.fuelType) {
    characteristics.push(parsedTechnicalData.fuelType);
  }

  if (parsedTechnicalData.gearBox) {
    characteristics.push(parsedTechnicalData.gearBox);
  }

  if (parsedTechnicalData.finalInspectionDate) {
    characteristics.push(parsedTechnicalData.finalInspectionDate);
  }

  return characteristics;
};
